import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const submissionHeaderContainerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const submissionHeaderLeftStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(2)};
`;

export const profileDetailsWrapperStyle = css`
  display: flex;
  flex-direction: column;
`;

export const nameRowStyle = css`
  display: flex;
  align-items: center;
`;

export const contactInfoRowStyle = css`
  display: flex;
  align-items: center;
  margin-top: ${theme.spacing(1)};
  gap: ${theme.spacing(2)};
`;

export const headerRightButtonsStyle = css`
  display: flex;
  gap: ${theme.spacing(2)};
  align-items: center;
  justify-content: center;
`;

export const buttonBorderStyle = css`
  border: 1px solid ${theme.colors.neutral40};
`;

export const lastNameStyle = css`
  font-size: ${theme.fontSize(20)};
  padding-left: ${theme.spacing(0.5)};
`;

export const patientPmsIdStyle = css`
  font-weight: 100;
  background-color: ${theme.colors.neutral5};
  border: 1px solid ${theme.colors.neutral5};
  border-radius: ${theme.borderRadius.small};
`;

export const headerPanelStyle = css`
  > div {
    display: flex;

    > div {
      display: flex;
      align-items: center;
      gap: ${theme.spacing(1)};
      overflow: hidden;
      flex: 1;
    }
  }
`;
